module.exports = __webpack_public_path__ + "img/android.d3f9fdfe.svg";